$.extend tower,
  initManageProjects: ->
    $wrapper = $('.manage-projects')
    $projects = $wrapper.find('.projects .project')
    return  unless $wrapper.length and $projects.length

    $wrapper.on 'change', '.project input[type="checkbox"]', ->
      refreshGroup()
    $wrapper.on 'click', '.group-select span[data-group]', groupClick

    refreshGroup()


groupClick = ->
  $group = $(@).toggleClass 'selected'
  $wrapper = $group.closest('.manage-projects')
  groupId = $group.data('group')

  if groupId == -1
    $projects = $wrapper.find('.project')
  else
    $projects = $wrapper.find(".project[data-group-ids*=#{ groupId }]")

  isSelected = $group.hasClass('selected')
  $projects.each ->
    $(@).find('input[type="checkbox"]').prop 'checked', isSelected

  refreshGroup()


refreshGroup = ->
  $wrapper = $('.manage-projects')
  $allProjects = $wrapper.find('.project')

  $wrapper.find('.group-select span[data-group]').each ->
    $group = $(@)
    groupId = $group.data('group')
    $projects = $allProjects

    if groupId isnt -1
      $projects = $projects.filter("[data-group-ids*=#{ groupId }]")

    if $projects.length
      $group.show()
      $group.toggleClass('selected', !$projects.find('input[type="checkbox"]:not(:checked)').length)
    else
      $group.hide()
